import { GroupIcon } from "lucide-react";
import { Trans, useTranslation } from "react-i18next";
import { IrrigationEventProto } from "verdi-web-client/Models/Scheduling/IrrigationEventProto";
import { NAMESPACES } from "@/i18n/constants";
import { WarningPopover } from "./warning-popover";

interface SetEventWarningProps {
    setEventEndTime: Date;
    setEventStartTime: Date;
    nearestFutureEvent: IrrigationEventProto;
    nowDate: Date;
}
export function SetEventWarning({
    setEventEndTime,
    setEventStartTime,
    nearestFutureEvent,
    nowDate,
}: SetEventWarningProps) {
    const isEventOngoing = setEventStartTime < nowDate && setEventEndTime > nowDate;
    const { t } = useTranslation(NAMESPACES.FEATURES.CARDS, {
        keyPrefix: "zone.on-demand-irrigation.set-event-warning",
    });

    // @ts-expect-error linkedIrrigationSet exists but is incorrectly typed as always undefined
    const setName = nearestFutureEvent.commandGroup?.linkedIrrigationSet?.name;
    const descriptionKey = isEventOngoing ? "description-current" : "description-upcoming";

    return (
        <WarningPopover
            title={t("title")}
            description={<Trans t={t} i18nKey={descriptionKey} values={{ setName: setName ?? "" }} />}
            icon={GroupIcon}
            triggerClassName={"border-set-event text-set-event"}
        />
    );
}
